import React from 'react';

import * as Dialog from '@radix-ui/react-dialog';

import {
    StyledClose,
    StyledContent,
    StyledOverlay,
    StyledTrigger,
    Form,
    Header,
    SectionBox,
    SendButton,
    SendButtonContainer,
    TitleHeader,
    AiFillCloseCircleIcon,
    FaUserPlusIcon
} from './styles';

import { FormEvent, useState } from 'react';

import { IClientProps } from '../../../interfaces';

interface INewClientProps {
    onClientCreated: (client: IClientProps) => void
}

const NewClient: React.FC<INewClientProps> = ({ onClientCreated }: INewClientProps) => {

    const [open, setOpen] = useState<boolean>(false);

    const [nome, setNome] = useState<string>('');
    const [dominio, setDominio] = useState<string>('');
    const [webhookBitrix, setWebhookBitrix] = useState<string>('');
    const [bitrixId, setBitrixId] = useState<string>('');
    const [jiraMain, setJiraMain] = useState<string>('');
    const [jiraSupport, setJiraSupport] = useState<string>('');

    function handleSubmitButton(event: FormEvent) {
        event.preventDefault();

        onClientCreated({
            dominio: dominio,
            idList: bitrixId,
            jiraMain: jiraMain,
            jiraSupport: jiraSupport,
            nome: nome,
            webhook: webhookBitrix,
            id: undefined
        });

        setOpen(false);
    }

    return (
        <Dialog.Root open={open} onOpenChange={setOpen}>
            <StyledTrigger>
                <FaUserPlusIcon /> <h2>Cliente</h2>
            </StyledTrigger>

            <Dialog.Portal>
                <StyledOverlay />
                <StyledContent>
                    <StyledClose>
                        <AiFillCloseCircleIcon />
                    </StyledClose>

                    <Header>
                        <TitleHeader>
                            Cadastrar cliente
                        </TitleHeader>
                    </Header>
                    <Form
                    onSubmit={handleSubmitButton}
                    >
                        <SectionBox>
                            <label htmlFor="clientName">
                                Nome da Empresa:
                            </label>
                            <input
                                type="text"
                                id="clientName"
                                autoComplete="off"
                                onChange={(e) => setNome(e.target.value)}
                                required
                            />
                        </SectionBox>

                        <SectionBox>
                            <label htmlFor="dominioBitrix">
                                Domínio Bitrix:
                            </label>
                            <input
                                type="text"
                                id="dominioBitrix"
                                autoComplete="off"
                                onChange={(e) => setDominio(e.target.value)}
                                required
                            />
                        </SectionBox>

                        <SectionBox>
                            <label htmlFor="webhookBitrix">
                                WebHook Bitrix:
                            </label>
                            <input
                                type="text"
                                id="webhookBitrix"
                                autoComplete="off"
                                onChange={(e) => setWebhookBitrix(e.target.value)}
                                required
                            />
                        </SectionBox>

                        <SectionBox>
                            <label htmlFor="bitrixId">
                                ID Lista de Clientes:
                            </label>
                            <input
                                type="number"
                                id="bitrixId"
                                autoComplete="off"
                                onChange={(e) => setBitrixId(e.target.value)}
                                required
                            />
                        </SectionBox>

                        <SectionBox>
                            <label htmlFor="jiraMain">
                                Código Jira:
                            </label>
                            <input
                                type="text"
                                id="jiraMain"
                                autoComplete="off"
                                onChange={(e) => setJiraMain(e.target.value)}
                                required
                            />
                        </SectionBox>

                        <SectionBox>
                            <label htmlFor="jiraSupport">
                                Código Jira Suporte:
                            </label>
                            <input
                                type="text"
                                id="jiraSupport"
                                autoComplete="off"
                                onChange={(e) => setJiraSupport(e.target.value)}
                                required
                            />
                        </SectionBox>
                        <SendButtonContainer>
                            <SendButton
                                // type='button'
                                // onClick={handleSubmitButton}
                            >
                                Adicionar
                            </SendButton>
                        </SendButtonContainer>

                    </Form>


                </StyledContent>
            </Dialog.Portal>

        </Dialog.Root>
    )

}

export default NewClient;